import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type { PostConversationalPreviewWorkflowProps, PostConversationalPreviewWorkflowResult } from "./types";

export const postConversationalPreviewWorkflow = reactQueryMutationAdapter(
  [],
  (props: PostConversationalPreviewWorkflowProps): Promise<PostConversationalPreviewWorkflowResult> => {
    return fetch(`/${props.appGroupId}/conversational/preview_workflow`, "POST", {
      session_id: props.sessionId,
      user_message: props.userMessage,
      conversational_workflow_payload: props.conversationalWorkflowPayload,
    });
  }
);
